export const mapCbexStatusColours = (status: string, theme: any): string => {
  switch (status) {
    case "Requested":
      return theme.appColors.customColors.cbexRequested;
    case "Confirmed":
      return theme.appColors.customColors.cbexConfirmed;
    default:
      return theme.appColors.customColors.cbexResultsCollected;
  }
};

export interface ActivityFilterValues {
  dateFrom: any;
  dateTill: any;
}
